var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-bottom-navigation',{staticClass:"hidden-md-and-up",attrs:{"grow":"","app":"","dark":this.$vuetify.theme.dark,"background-color":this.$vuetify.theme.dark?'#212121':'white',"color":this.$vuetify.theme.dark?'white':'primary'}})}
var staticRenderFns = []

export { render, staticRenderFns }